import './styles/main.scss'
import './icons'

import './slider-logo'

const videos = document.querySelectorAll('[js-video]')
const play = document.querySelectorAll('[js-video-play]')

if (videos.length > 0) {
  play.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      videos[index].querySelector('.video-foreground').style.opacity = 0;
      
      setTimeout(() => {
        videos[index].querySelector('.video-foreground').style.display = 'none';
        videos[index].querySelector('.video-background iframe').src =  `${videos[index].querySelector('.video-background iframe').src}&autoplay=1`
      }, 300)
    })
  })
}


// FILTERS

const items = document.querySelectorAll('[js-team-item]')
const filters = document.querySelectorAll('[js-team-filter] li')
const selectFilter = document.querySelector('[js-team-select]')
let filterActive = 0
let filterSlug = ""

if (items.length > 0) {
  filters.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      if (filterActive !== index) document.querySelector('[js-team-filter] li.is-active').classList.remove('is-active')
      btn.classList.add('is-active')
      filterActive = index
      filterSlug = btn.dataset.slug 
      selectFilter.selectedIndex = filterActive

      for(const item of items) {
        if(item.dataset.slug === filterSlug || filterSlug === '') {
          setTimeout(() => {
            item.style.display = 'block'
          }, 200)
          setTimeout(() => {
            item.style.opacity = 1
          }, 600)

        } else {
          item.style.opacity = 0

          setTimeout(() => {
            item.style.display = 'none'
          }, 300)
        }
      }
    })
  })

  selectFilter.addEventListener('change', (e) => {
    e.preventDefault()
    filters[filterActive].classList.remove('is-active')
    filterSlug = selectFilter.value
    filterActive = selectFilter.selectedIndex
    filters[filterActive].classList.add('is-active')
    for(const item of items) {
      if(item.dataset.slug === filterSlug || filterSlug === '') {
        setTimeout(() => {
          item.style.display = 'block'
        }, 200)
        setTimeout(() => {
          item.style.opacity = 1
        }, 600)

      } else {
        item.style.opacity = 0

        setTimeout(() => {
          item.style.display = 'none'
        }, 300)
      }
    }
  })
}

const scroll = document.querySelector('[js-scroll-container]')
const scrollBtn = document.querySelector('[js-scroll]')
if (scroll) {
  scrollBtn.addEventListener('click', () => {
    window.scrollTo({
      top: scroll.offsetHeight + scroll.offsetTop,
      left: 0,
      behavior: 'smooth'
    })
  })
}


// TABS

const btnTabs = document.querySelectorAll('[js-tab-btn]')
const selectTabs = document.querySelector('[js-tab-select]')
const contentTabs = document.querySelectorAll('[js-tab-content]')

if (btnTabs.length) {
  let toggleActive = 0
  btnTabs.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      btnTabs[toggleActive].classList.remove('is-active')
      contentTabs[toggleActive].classList.remove('is-active')
      btn.classList.add('is-active')
      contentTabs[index].classList.add('is-active')
      toggleActive = index
    })
  })

  selectTabs.addEventListener('change', (e) => {
    e.preventDefault()
    btnTabs[toggleActive].classList.remove('is-active')
    contentTabs[toggleActive].classList.remove('is-active')
    toggleActive = selectTabs.selectedIndex
    contentTabs[toggleActive].classList.add('is-active')
    btnTabs[toggleActive].classList.radd('is-active')
  })
}


//MENU
const btnMenu = document.querySelector('[js-menu-btn]')
const menu = document.querySelector('[js-menu]')
const menuLink = document.querySelectorAll('.submenu a')

if(btnMenu && menu) {
  btnMenu.addEventListener('click', () => {
    btnMenu.classList.toggle('is-open')
    menu.classList.toggle('is-open')
  })
}

for (const link of menuLink) {
  link.addEventListener('click', () => {
    btnMenu.classList.remove('is-open')
    menu.classList.remove('is-open')
  })
}

const buttonOnTop = document.querySelector('[js-on-top]')
if (buttonOnTop) {
  buttonOnTop.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  })

  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      buttonOnTop.classList.add('is-appear')
    } else {
      buttonOnTop.classList.remove('is-appear')

    }
  })
}


/**
 * FORM
 */

const formStep = document.querySelectorAll('.contact-form-step')



if (formStep.length > 0) {
  const inputName = document.querySelector('.input-name input')
  const inputEmail = document.querySelector('.input-email input')
  const inputLastName = document.querySelector('.input-lastname input')
  const inputRoleRadio = document.querySelectorAll('.input-role input')
  const inputSchoolRadio = document.querySelectorAll('.input-nameschool input')
  const inputInterestRadio = document.querySelectorAll('.input-intereset input')
  const inputSchool = document.querySelector('.input-nameschool')
  const inputNameSchool = document.querySelector('.input-school')
  const inputFileCV = document.querySelector('.contact-form-file-cv input')
  const inputFileCVLabel = document.querySelector('.contact-form-file-cv-label')
  const inputFileMotivation = document.querySelector('.contact-form-file-motivation input')
  const inputFileMotivationLabel = document.querySelector('.contact-form-file-motivation-label')

  // const inputNameSchool = document.querySelector('.input-s')
  const goStep2 = document.querySelector('[data-go="2"]')
  const goStep3 = document.querySelector('[data-go="3"]')
  const section1 = document.querySelector('[data-step="1"]')
  const section2 = document.querySelector('[data-step="2"]')
  const section3 = document.querySelector('[data-step="3"]')

  const form = document.querySelector('.wpcf7-form')

  document.addEventListener('keydown', (e) => {
    if (e.which == 13) {
      if (section2.classList.contains('is-active')) {
        e.preventDefault();
        if (step2()) {
          section2.classList.remove('is-active')
          section3.classList.add('is-active')
        }
      }
      if (section1.classList.contains('is-active')) {
        e.preventDefault();
        if (step1()) {
          section1.classList.remove('is-active')
          section2.classList.add('is-active')
        }
      }
    }
  })

  document.addEventListener('keypress', (e) => {
    if (e.which == 13) {
      e.preventDefault()
    }
  })

  document.addEventListener('keydown', (e) => {
    if (e.which == 13) {
      e.preventDefault()
    }
  })

  form.addEventListener('keypress', (e) => {
    if (e.which== 13) {
      e.preventDefault()
    }
  })
  form.addEventListener('keydown', (e) => {
    if (e.which== 13) {
      e.preventDefault()
    }
  })
  form.addEventListener('keyup', (e) => {
    if (e.which == 13) {
      if (section2.classList.contains('is-active')) {
        e.preventDefault();

        if (step2()) {
          section2.classList.remove('is-active')
          section3.classList.add('is-active')
        }
      }
      if (section1.classList.contains('is-active')) {
        e.preventDefault();
        if (step1()) {
          section1.classList.remove('is-active')
          section2.classList.add('is-active')
        }
      }
    }
  })

  goStep2.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (step1()) {
      section1.classList.remove('is-active')
      section2.classList.add('is-active')
    }
  })

  goStep3.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (step2()) {
      section2.classList.remove('is-active')
      section3.classList.add('is-active')
    }
  })
  
  for (const radio of inputRoleRadio) {
    radio.addEventListener('change', () => {
      inputSchool.style.display = 'block'
      if (document.querySelector('.input-role .contact-form-error')) document.querySelector('.input-role .contact-form-error').remove()
    })
  }

  for (const radio of inputSchoolRadio) {
    radio.addEventListener('change', () => {
      inputNameSchool.style.display = 'block'
      if (document.querySelector('.input-nameschool .contact-form-error')) document.querySelector('.input-nameschool .contact-form-error').remove()
    })
  }

  inputFileCV.addEventListener('change', (e) => {
    const files = e.target.files;
    if (files && files[0]) {
      const fileName = files[0].name;
      inputFileCVLabel.innerHTML = fileName
    } else {
      inputFileCVLabel.innerHTML = 'Aucun fichier'
    }
  })
  inputFileMotivation.addEventListener('change', (e) => {
    const files = e.target.files;
     if (files && files[0]) {
      const fileName = files[0].name;
      inputFileMotivationLabel.innerHTML = fileName
    } else {
      inputFileMotivationLabel.innerHTML = 'Aucun fichier'
    }
    
  })

  function step1() {
    let valid = true
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    
    if (inputName.value === '') {
      createError(inputName.parentElement)
      valid = false
    } else {
      if(inputName.parentElement.querySelector('.contact-form-error')) inputName.parentElement.querySelector('.contact-form-error').remove()
    }
    
    if (inputLastName.value === '') {
      createError(inputLastName.parentElement)
      valid = false
    } else {
      if(inputLastName.parentElement.querySelector('.contact-form-error')) inputLastName.parentElement.querySelector('.contact-form-error').remove()
    }

    if (inputEmail.value === '') {
      createError(inputEmail.parentElement)
      valid = false
    } else {
      if (!inputEmail.value.match(validRegex)) {
        createError(inputEmail.parentElement, 'Veuillez compléter une adresse électronique valide.')
        valid =false
      }
      else {
        if(inputEmail.parentElement.querySelector('.contact-form-error')) inputEmail.parentElement.querySelector('.contact-form-error').remove()
      }
      
    }

    return valid
  }


  function step2() {
    let valid  = true
    if (inputNameSchool.querySelector('input').value === '') {
      createError(inputNameSchool.querySelector('input').parentElement)
      valid = false
    } else {
      if(inputNameSchool.querySelector('input').parentElement.querySelector('.contact-form-error')) inputNameSchool.querySelector('input').parentElement.querySelector('.contact-form-error').remove()
    }
    
    let validRadio = false
    for (const radio of inputRoleRadio) {
      if (radio.checked) validRadio = true
    }

    if (!validRadio) {
      createError(document.querySelector('.input-role .wpcf7-form-control'))
      valid = false
    } else {
      if(document.querySelector('.input-role .wpcf7-form-control').parentElement.querySelector('.contact-form-error')) document.querySelector('.input-role .wpcf7-form-control').parentElement.querySelector('.contact-form-error').remove()
      
    }

    validRadio = false
    for (const radio of inputSchoolRadio) { 
      if (radio.checked) validRadio = true
    }

    if (!validRadio) {
      createError(document.querySelector('.input-nameschool .wpcf7-form-control'))
      valid = false
    } else {
      if(document.querySelector('.input-nameschool .wpcf7-form-control').parentElement.querySelector('.contact-form-error')) document.querySelector('.input-nameschool .wpcf7-form-control').parentElement.querySelector('.contact-form-error').remove()
      
    }
    
    return valid
  }

  function createError(parent, error = false) {
    if(parent.querySelector('.contact-form-error')) parent.querySelector('.contact-form-error').remove()
    const span = document.createElement('span')
    span.classList.add('contact-form-error')
    span.innerHTML = error ? error : 'Ce champ ne peut pas être vide';

    parent.appendChild(span)
  }
}


const blogSelected = document.querySelector('[js-blog-select]')

if (blogSelected) {
  blogSelected.addEventListener('change', () => {
    console.log(blogSelected.value)
    window.location.href = blogSelected.value
  })
}


const hasMobileItem = document.querySelectorAll('.has-mobile-children')
const submenuItem = document.querySelectorAll('.submenu')

hasMobileItem.forEach((item, index) => {
  item.addEventListener('click', () => {
    if (document.querySelector('.submenu.is-open')) {
      document.querySelector('.submenu.is-open').style = ''
      document.querySelector('.submenu.is-open').classList.remove('is-open')
    }
    submenuItem[index].classList.add('is-open')
    submenuItem[index].style.display = 'block'
  })
})

window.addEventListener('resize', () => {
  if (document.querySelector('.submenu.is-open')) {
    document.querySelector('.submenu.is-open').style = ''
    document.querySelector('.submenu.is-open').classList.remove('is-open')
  }
})